import React from 'react'
import { useQuery } from '@apollo/client'
import { Box, Typography, CircularProgress, FormLabel } from '@mui/material'
import WeekSelector from './WeekSelector'
import query from './query.graphql'

const DateSelection = ({
  location,
  camper,
  session,
  cartProduct,
  camperSession,
  onToggleDate
}) => {
  // Fetch location weeks data for this specific location
  const { loading, data } = useQuery(query, {
    variables: { locationId: location.id }
  })

  // Get selected date IDs from cart product (local Redux state)
  const selectedDateIds =
    cartProduct?.reservationDays?.map(rd => rd.locationDayId) || []

  // Get reserved date IDs from existing reservations (exclude current cart selections)
  const reservedDateIds =
    camperSession?.reservationDays
      ?.filter(rd => !selectedDateIds.includes(rd.locationDay.id))
      ?.map(rd => rd.locationDay.id) || []

  // Wrap onToggleDate to include camper and session
  const handleToggleDate = locationDay => {
    onToggleDate(locationDay, { camper, session })
  }

  if (loading) {
    return (
      <Box mt={3} display='flex' justifyContent='center'>
        <CircularProgress />
      </Box>
    )
  }

  const locationWeeks = [...(data?.locations?.[0]?.locationWeeks || [])].sort(
    (a, b) => new Date(a.startDate) - new Date(b.startDate)
  )

  return (
    <Box mt={3}>
      <FormLabel>2. Select Dates</FormLabel>
      {locationWeeks.map(week => (
        <WeekSelector
          key={week.id}
          week={week}
          selectedDateIds={selectedDateIds}
          reservedDateIds={reservedDateIds}
          onToggleDate={handleToggleDate}
        />
      ))}
    </Box>
  )
}

export default DateSelection
